import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { LocalstorageService, UserService } from "../../../shared";
import * as moment from "moment";

@Injectable()
export class AuthguardService implements CanActivate {
	constructor(private userService: UserService, private router: Router, private localService: LocalstorageService) {}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		var currentUser = this.userService.getCurrentUser();
		var appItem = state.url;

		var isafter = false;
		var hasAccess = true;
		var redirectFirst = "";
		if (currentUser) {
			var today = moment(new Date()).format("MM/DD/YYYY");
			isafter = moment(today).isAfter(moment(currentUser.c_date));

			var lstRouterLinks = this.localService.getItem("lstRouterLinks");

			if (lstRouterLinks != undefined && lstRouterLinks.length > 0) {
				hasAccess = this.FindStringInList(appItem, lstRouterLinks);
				redirectFirst = lstRouterLinks[0];
			}
		}

		// if (isafter || !currentUser || !currentUser.isLoggedIn) {
		if (isafter || !currentUser || !currentUser.isLoggedIn) {
			this.router.navigate(["/login"]);
			return false;
		} else if (hasAccess == false) {
			this.router.navigate([redirectFirst]);
			return false;
		} else {
			return true;
		}
	}

	FindStringInList(str: string, lstStr: string[]) {
		if (lstStr.length == 0) {
			return false;
		}
		var Start = 0;
		var End = lstStr.length - 1;

		while (Start <= End) {
			let Mid = Math.floor((Start + End) / 2);

			if (String(str) == String(lstStr[Mid])) {
				return true;
			}

			if (String(str) < String(lstStr[Mid])) {
				End = Mid - 1;
			} else {
				Start = Mid + 1;
			}
		}

		return false;
	}
}
